import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import { useAppSelector } from '../store';

import Icon from './icon';
import { YandexMetrikaEvent } from '../types/metrica/YandexMetrikaEvent';
import { ymEvent } from '../hooks/useYandexMetrika';

interface SidebarProps {
  className?: string;
  isOpen: boolean;
}

const Sidebar = ({ className, isOpen }: SidebarProps) => {
  const { hasNew } = useAppSelector((state) => state.messages);

  return (
    <aside className={cn(`sidebar ${className}`, { 'is-open': isOpen })}>
      <nav className="sidebar-nav">
        <ul className="menu">
          <li className="menu-item">
            <NavLink
              end
              to="/"
              onClick={() => ymEvent(YandexMetrikaEvent.LK_CABINET_NAV_CLICK_DOCS)}
              className={({ isActive }) => cn('menu-link', { 'is-active': isActive })}
            >
              <Icon
                name="shopping"
                className="fill-current mr-2 text-royalblue"
                width={18}
                height={18}
              />
              Мои полисы
            </NavLink>
          </li>

          <li className="menu-item">
            <NavLink
              to="/messages"
              onClick={() => ymEvent(YandexMetrikaEvent.LK_CABINET_NAV_CLICK_MESSAGES)}
              className={({ isActive }) => cn('menu-link', { 'is-active': isActive })}
            >
              <div className={cn('menu-icon', { 'has-dot': hasNew })}>
                <Icon
                  name="envelope"
                  className="fill-current mr-2 text-royalblue"
                  width={18}
                  height={18}
                />
              </div>
              Сообщения
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
